/* eslint-disable import/first */
require('es6-promise').polyfill();

import 'isomorphic-fetch';

import { mockFetch } from './mockFetch';
import { isomorphicFetch } from './isomorphicFetch';

const requestHeaders = new Headers();

export function getDefaultHeaders() {
  return requestHeaders;
}

export function setAuthorization(storeCookie) {
  return requestHeaders.set('Authorization', `Bearer ${storeCookie}`);
}

export async function fetch(url, options = {}) {
  const defaultOptions = {
    useMock: false,
    headers: getDefaultHeaders()
  };

  const currentOptions = {
    ...defaultOptions,
    ...options
  };

  if (currentOptions.useMock) {
    return mockFetch(url, currentOptions);
  }

  return isomorphicFetch(url, currentOptions);
}


function fetchWithHttpProxy(url, opts = {}) {
  if (typeof window === 'undefined' && process.env.http_proxy) {
    const httpProxy = (process.env.http_proxy.indexOf('http://') !== 0 ? 'http://' : '') + process.env.http_proxy;
    opts.agent = require('https-proxy-agent')(httpProxy); // eslint-disable-line global-require
  }
  return fetch(url, opts);
}

export function fetchFromCDN(url, opts = {}) {
  return fetchWithHttpProxy(url, opts);
}
